@if (productData && hasValidTranslations) {
<section class="section-5 mt-4 pt-4 mb-6 mb-lg-7">
    @for (overviewKeys of groupedContent['SECTION-5']; track overviewKeys;) {
    <div class="container text-center mb-4">
        <div class="col-12 col-md-8 col-lg-10 offset-md-2 offset-lg-1">
            @if (overviewKeys.headingText) {
            <h2
                [innerHTML]="overviewKeys.headingText"
                class="text-blue-300"
            ></h2>
            } @if (overviewKeys.descriptionText) {
            <div [innerHTML]="overviewKeys.descriptionText"></div>
            }
        </div>
    </div>
    } @if (componentData$ | async) { @let content = componentData$ | async;
    <div class="container">
        <div class="row justify-content-center">
            @if (content['card-type'] === 'icon') { @for (card of
            content['card-item']; track card;) {
            <div class="col-12 col-md-6 col-lg-4 mb-3">
                <vision2-card
                    [buttonText]="card['button-text']"
                    [buttonUrl]="card['button-url']"
                    [description]="card['description']"
                    [image]="card['image']"
                    [imageAlt]="card['image-alt-text']"
                    [imageClass]="'rounded-4'"
                    [imageSizes]="
                        '(min-width: 992px) 34vw, (min-width: 768px) 50vw, 100vw'
                    "
                    [linkUrl]="card['link-url']"
                    [linkText]="card['link-text']"
                    [title]="card['title']"
                    [cardClass]="'pt-4 px-2 mx-auto text-center'"
                    [cardColor]="'bg-gray-30'"
                    [headingClass]="'text-gray-100'"
                ></vision2-card>
            </div>
            } } @if (content['card-type'] === 'full-image') {
            <div class="row">
                @for (card of content['card-item']; track card;) {
                <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <vision2-card
                        [buttonText]="card['button-text']"
                        [buttonUrl]="card['button-url']"
                        [description]="card['description']"
                        [image]="card['image']"
                        [imageAlt]="card['image-alt-text']"
                        [imageClass]="'rounded-4 w-100 mb-3'"
                        [imageSizes]="
                            '(min-width: 992px) 34vw, (min-width: 768px) 50vw, 100vw'
                        "
                        [linkUrl]="card['link-url']"
                        [linkText]="card['link-text']"
                        [modalVideoId]="card['video-url']"
                        [title]="card['title']"
                        [cardClass]="'px-2 mx-auto text-center text-bg-light'"
                        [cardColor]="'bg-transparent'"
                    >
                    </vision2-card>
                </div>
                }
            </div>
            }
        </div>
    </div>
    }
</section>
}
